export const translations = {
	nav: {
		title: 'Navegación',
		app: 'Certificado de doazón',
	},
	footer: {
		poweredBy: 'Feito por',
		copyright: '© {{year}} WorldCoo. Todos os dereitos reservados.',
		termsAndConditions: 'Termos e condicións',
		privacyPolicy: 'Política de privacidade',
	},
	categories: {
		basicNeeds: 'Auga e Enerxía',
		humanRights: 'Dereitos Humanos',
		education: 'Educación',
		emergency: 'Emerxencias',
		feeding: 'Fame e Seguridade Alimentaria',
		beneficiaries: 'Beneficiarios',
		directBeneficiaries: '{{count}} directos',
		indirectBeneficiaries: '{{count}} indirectos',
		environment: 'Medio Ambiente',
		habitat: 'Vivenda e Pobreza',
		health: 'Saúde',
	},
	statistics: {
		campaigns: 'Campañas',
		donations: 'Doazóns',
		collected: 'Recaudado',
		collectedFromBudget: 'Obxectivo de {{budget}}',
	},
	filters: {
		year: 'Ano',
		state: 'Estado',
		cause: 'Causa',
		active: 'Activa',
		finished: 'Finalizada',
		default: 'Por defecto',
		toggle: 'Alternar {{value}}',
	},
	actions: {
		close: 'Pechar',
		search: 'Busca calquera cousa',
		filter: 'Filtrar',
		viewCampaign: 'Ver campaña',
		makeDonation: 'Facer doazón',
		donate: 'Doar',
		selectLanguage: 'Seleccionar idioma',
		backToHome: 'Volver ao inicio',
		funded: 'Financiado',
		clear: 'Limpar Filtros',
		apply: 'Aplicar',
		goBack: 'Volver',
		previous: 'Anterior',
		next: 'Seguinte',
	},
	portal: {
		heroButton: 'Comeza a doar',
		campaigns: {
			title: 'Campañas',
			description: 'Explora as nosas iniciativas e escolle a causa que máis te inspire',
			notFound: 'Non hai campañas',
		},
		campaignFunded: 'Campaña financiada',
		percentageFunded: '{{percentage}}% Financiada',
		aCampaignFrom: 'Unha campaña de: {{ngoName}}',
		beneficiaries: 'Beneficiarios',
		directBeneficiaries: '{{count}} directos',
		indirectBeneficiaries: '{{count}} indirectos',
		sdgs: {
			title: 'Obxectivos de Desenvolvemento Sostible',
			1: 'Fin da Pobreza',
			2: 'Fame Cero',
			3: 'Saúde e Benestar',
			4: 'Educación de Calidade',
			5: 'Igualdade de Xénero',
			6: 'Auga Limpa e Saneamento',
			7: 'Enerxía Accesible e Non Contaminante',
			8: 'Traballo Decente e Crecemento Económico',
			9: 'Industria, Innovación e Infraestrutura',
			10: 'Redución das Desigualdades',
			11: 'Cidades e Comunidades Sostibles',
			12: 'Produción e Consumo Responsables',
			13: 'Acción polo Clima',
			14: 'Vida Submarina',
			15: 'Vida de Ecosistemas Terrestres',
			16: 'Paz, Xustiza e Institucións Sólidas',
			17: 'Alianzas para Lograr os Obxectivos',
		},
	},
	faq: {
		title: 'Preguntas frecuentes',
		description: 'Respostas ás dúbidas máis comúns dos nosos doantes.',
	},
	campaign: {
		objectives: 'Obxectivos da campaña',
		description: 'Descrición',
		activities: 'Actividades',
		beneficiaries: 'Quen se beneficiará?',
		updatesAndLinks: 'Máis información e ligazóns',
		from: 'Dende:',
		until: 'Ata:',
	},
	campaigns: {
		notTranslated: 'Este proxecto aínda non está dispoñible no teu idioma.',
	},
	placeholders: {
		amount: 'Outra cantidade',
	},
	donate: {
		title: 'Fai a túa doazón',
		details: {
			title: 'Engade os teus datos para continuar',
			subtitle:
				'Completa os teus datos para finalizar a túa doazón. Tamén podes solicitar o teu certificado fiscal aquí.',
		},
		certificate: {
			title: 'Recupera ata {{amount}}',
			subtitle: 'Certifica a túa doazón cun clic e aparecerá automaticamente no teu borrador da Renda.',
		},
	},
	errors: {
		required: 'Este campo é obrigatorio',
		invalidExtref: 'O código non é válido, debe seguir este formato: {{format}}',
		email: 'O enderezo de correo electrónico está mal formatado.',
		emailAlreadyExists: 'Este correo electrónico xa está en uso.',
		password: 'O teu contrasinal debe ter 6 caracteres ou máis.',
		confirmationCode: 'Por favor, introduce o código de confirmación.',
		documentType: 'Tipo de documento non válido',
		termsAndConditions: 'Debes aceptar os termos e condicións',
		amount: 'Por favor, selecciona ou introduce unha cantidade válida.',
		signIn: 'Erro ao iniciar sesión',
		emailsDoNotMatch: 'Os enderezos de correo electrónico non coinciden.',
		passwordsDoNotMatch: 'Os contrasinais non coinciden.',
		imageFormat: 'Por favor, solta un ficheiro de imaxe',
		camera: 'Non se pode acceder á cámara. Por favor, asegúrate de ter concedido permiso.',
		expiredCode: 'O código caducou.',
		codeMismatch: 'O código é incorrecto. Por favor, inténtao de novo.',
		notAuthorized: 'Credenciais incorrectas. Por favor, inténtao de novo.',
		userDoesNotExist: 'O usuario non existe.',
		userNotConfirmed: 'Usuario non confirmado. Por favor, confirma o teu enderezo de correo electrónico primeiro.',
		userAlreadyConfirmed: 'O usuario xa foi confirmado.',
		documentNumberExists: 'O número de documento xa está en uso.',
		limitExceeded: 'Alcanzaches o límite de intentos. Por favor, inténtao de novo máis tarde.',
		invalidPassword: 'O contrasinal non é válido, debe ter polo menos 6 caracteres e non pode conter espazos.',
		captchaFailed: 'CAPTCHA verification failed. Please try again.',
		internal: 'Sentímolo, houbo un problema, o noso equipo xa foi informado, inténtao de novo máis tarde.',
	},
	documentTypes: {
		id: 'DNI',
		passport: 'Pasaporte',
		taxId: 'Identificación fiscal',
		nie: 'NIE',
		others: 'Outros',
	},
	labels: {
		code: 'Código',
		email: 'Correo electrónico',
		repeatEmail: 'Repita o seu correo electrónico',
		password: 'Contrasinal',
		confirmPassword: 'Confirmar contrasinal',
		amount: 'Cantidade da doazón',
		documentType: 'Tipo de documento',
		documentNumber: 'Número de documento',
		name: 'Nome',
		lastName: 'Apelido',
		streetName: 'Nome da rúa',
		streetNumber: 'Número',
		additionalInfo: 'Información adicional',
		postalCode: 'Código postal',
		city: 'Cidade',
		country: 'País',
		region: 'Rexión',
		province: 'Provincia',
		certificate: 'Quero recibir un certificado fiscal',
		termsAndConditions1:
			'Esta información só se compartirá coas organizacións receptoras das túas doazóns co fin de xerar o correspondente certificado fiscal. Lea os ',
		termsAndConditions2: 'termos e condicións',
		language: 'Idioma',
	},
	checkout: {
		title: 'Método de pago',
	},
	recaptcha: {
		description: 'protexido por reCAPTCHA.',
		privacy: 'Privacidade',
		terms: 'Termos',
	},
	thanks: {
		title: 'Grazas\n pola túa doazón!',
		description:
			'En breve recibirás un correo de confirmación con todos os detalles. Xuntos estamos a construír un futuro mellor!',
	},
	termsAndConditions: {
		title: 'Termos de Protección de datos',
		labelText: 'Lin, entendo e acepto os termos de ',
		labelLink: 'Protección de Datos de {{name}}',
		accept: 'Lin, entendo e acepto',
		responsible: {
			title: 'Responsable',
			description: 'WORLDCOO S.L.',
		},
		purpose: {
			title: 'Finalidade',
			description:
				'Xestionar a relación comercial en todos os seus ámbitos, así como a súa doazón e a súa solicitude de certificado, e o envío de comunicacións comerciais por vía electrónica.',
			descriptionNgo:
				'A captación de fondos para proxectos da ONG, mantelo informado sobre a ONG e a evolución do proxecto para o que doou fondos e a emisión de certificados de desgravación fiscal.',
		},
		legitimacy: {
			title: 'Lexitimación',
			description: 'A base legal para o tratamento dos seus datos é a obtención do seu consentimento.',
		},
		recipients: {
			title: 'Destinatarios',
			description: 'Non se cederán datos a terceiros salvo que exista obriga legal para iso.',
		},
		rights: {
			title: 'Dereitos',
			description:
				'Ten dereito a acceder, rectificar e suprimir os datos, así como outros dereitos, como se explica na información adicional.',
		},
		additionalInfo: {
			title: 'Información adicional',
			description:
				'Pode consultar información adicional e detallada sobre Protección de Datos na nosa páxina <a href="https://www.worldcoo.com/gdpr">web</a> ou ben contactando a <a href="mailto:rgpd@worldcoo.com">rgpd@worldcoo.com</a>.',
			descriptionNgo:
				'Pode consultar a información adicional e detallada sobre Protección de Datos na web de cada ONG.\n\n<b>{{ngoName}}</b>',
		},
	},
};
